export const statusStyleArray = [
  {
    status: "AWAITING_CONTRACTOR_CONFIRMATION",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "APPROVED",
    color: "#096dd9",
    backgroundColor: "#e6f7ff",
  },
  {
    status: "AWAITING_HOME_OWNER_CONFIRMATION",
    backgroundColor: "#d46b08",
    color: "#fff7e6",
  },
  {
    status: "INITIATED",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  {
    status: "completed",
    color: "#389e0d",
    backgroundColor: "#f6ffed",
  },
  {
    status: "DRAFT",
    backgroundColor: "#d46b08",
    color: "#fff7e6",
  },
  {
    status: "PAID",
    color: "#fff",
    backgroundColor: "rgb(56, 158, 13)",
  },
  {
    status: "delivered",
    color: "#389e0d",
    backgroundColor: "#f6ffed",
  },
  {
    status: "APPROVED_BY_HOME_OWNER",
    backgroundColor: "#c41d7f",
    color: "#fff0f6",
  },
];

export const preventabilityStatusStyleArray = [
  {
    status: "High",
    color: "#d4380d",
    backgroundColor: "#fff2e8",
    border: "1px solid #ffbb96",
  },
  {
    status: "Medium",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
    border: "1px solid #ffd591",
  },
  {
    status: "Low",
    color: "#389e0d",
    backgroundColor: "#f6ffed",
    border: "1px solid #b7eb8f",
  },
];